import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayname',
    pure: true,
    standalone: false
})
export class DisplayNamePipe implements PipeTransform {
  public transform(object: { firstName?: string; lastName?: string } | string) {
    if (!object) {
      return '';
    }
    if (typeof object === 'string') {
      return object;
    }

    if (object.firstName && object.lastName) {
      return `${object.firstName} ${object.lastName}`;
    }

    if (object.firstName) {
      return object.firstName;
    }

    if (object.lastName) {
      return object.lastName;
    }
  }
}
